import { render, staticRenderFns } from "./topShow.vue?vue&type=template&id=612a80cc&scoped=true&"
import script from "./topShow.vue?vue&type=script&lang=js&"
export * from "./topShow.vue?vue&type=script&lang=js&"
import style0 from "./topShow.vue?vue&type=style&index=0&id=612a80cc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612a80cc",
  null
  
)

export default component.exports